import type { FileRouteTypes } from "@/routeTree.gen";

type To = FileRouteTypes["to"];
type FullPath = FileRouteTypes["fullPaths"];

export const APP_ROUTES_TO = {
    ROOT: "/",
    CALLS: "/calls",
    CALL_DETAILS: "/calls/$callId",
    AI: "/ai",
    AI_DIMENSION_DEFINITIONS: "/ai/dimension-definitions",
    AI_DIMENSIONS: "/ai/dimensions",
    MANAGEMENT: "/management",
    MANAGEMENT_PHONE_NUMBERS: "/management/phone-numbers",
    MANAGEMENT_CUSTOM_PAGES: "/management/custom-pages",
    MANAGEMENT_TEAMS: "/management/teams",
    MANAGEMENT_USERS: "/management/users",
    CALENDAR: "/calendar",
    CALENDAR_APPOINTMENTS: "/calendar/appointments",
    EVENTS: "/events",
    EVENT_ENTRY: "/events/$id",
    EVENT_RULES: "/events/$id/rules",
    EVENT_RULE: "/events/$id/rules/$planId",
    EVENT_SLOTS: "/events/$id/slots",
    EVENT_BOOKINGS: "/events/$id/bookings",
    MANAGEMENT_SCHEDULES: "/management/schedules",
    MANAGEMENT_SCHEDULES_MANAGE: "/management/schedules/manage",
    PERFORMANCE: "/performance",
    PERFORMANCE_KPIS: "/performance/kpis",
    PERFORMANCE_QUALITY_WATCH: "/performance/quality-watch",
    PERFORMANCE_AGENT_QUALITY_MATRIX: "/performance/agent-quality-matrix",
    PERFORMANCE_CALL_VOLUME: "/performance/call-volume",
    PERFORMANCE_CALENDAR_CAPACITIES: "/performance/calendar-capacities",
    PERFORMANCE_APPOINTMENT_ANALYTICS: "/performance/appointment-analytics",
    PERFORMANCE_REACHABILITY_ANALYSIS: "/performance/reachability-analysis",
    PERFORMANCE_REPORTS: "/performance/reports",
    PERFORMANCE_CALL_EXPORTS: "/performance/call-exports",
    PERFORMANCE_SETTING_PRIORITY_REPORT: "/performance/setting-priority-report",
    PERFORMANCE_SETTING_PRIORITY_LEADS:
        "/performance/setting-priority-report/setting-priority-leads/$language/$priority",
    PROFILE: "/profile",
    SETTINGS: "/settings",
    CALENDARS: "/calendars",
    CALENDAR_DETAILS: "/calendars/$id",
    APPOINTMENTS: "/appointments",
    RECORD_DETAILS: "/record-details/$recordId/$moduleType",
    BLOG: "/blog",
    BLOG_DETAIL: "/blog/$id",
    HELP_CENTER: "/help-center",
    LISTS: "/lists",
    INCIDENTS: "/incidents",
    CUSTOM_PAGE: "/custom-page/$slug",
    TESTING: "/testing",
    TESTING_KPIS_REPORT: "/testing/kpis-report",
    TESTING_INCIDENT_ANALYTICS: "/testing/incident-analytics",
    PRP_SCRIPT: "/prp-script",
    HOTEL_CAPACITY: "/hotel-capacity",
} as const satisfies Record<string, To>;

export const APP_ROUTES_FULL = {
    ROOT: APP_ROUTES_TO.ROOT,
    CALLS: `${APP_ROUTES_TO.CALLS}/`,
    CALL_DETAILS: `${APP_ROUTES_TO.CALL_DETAILS}/`,
    AI: APP_ROUTES_TO.AI,
    AI_DIMENSION_DEFINITIONS: APP_ROUTES_TO.AI_DIMENSION_DEFINITIONS,
    AI_DIMENSIONS: APP_ROUTES_TO.AI_DIMENSIONS,
    MANAGEMENT: APP_ROUTES_TO.MANAGEMENT,
    MANAGEMENT_PHONE_NUMBERS: `${APP_ROUTES_TO.MANAGEMENT_PHONE_NUMBERS}/`,
    MANAGEMENT_CUSTOM_PAGES: `${APP_ROUTES_TO.MANAGEMENT_CUSTOM_PAGES}/`,
    MANAGEMENT_TEAMS: `${APP_ROUTES_TO.MANAGEMENT_TEAMS}/`,
    MANAGEMENT_USERS: `${APP_ROUTES_TO.MANAGEMENT_USERS}/`,
    CALENDAR: APP_ROUTES_TO.CALENDAR,
    CALENDAR_APPOINTMENTS: `${APP_ROUTES_TO.CALENDAR_APPOINTMENTS}/`,
    EVENTS: `${APP_ROUTES_TO.EVENTS}/`,
    EVENT_ENTRY: APP_ROUTES_TO.EVENT_ENTRY,
    EVENT_RULES: `${APP_ROUTES_TO.EVENT_RULES}/`,
    EVENT_RULE: APP_ROUTES_TO.EVENT_RULE,
    EVENT_SLOTS: `${APP_ROUTES_TO.EVENT_SLOTS}/`,
    EVENT_BOOKINGS: `${APP_ROUTES_TO.EVENT_BOOKINGS}/`,
    MANAGEMENT_SCHEDULES: APP_ROUTES_TO.MANAGEMENT_SCHEDULES,
    MANAGEMENT_SCHEDULES_MANAGE: `${APP_ROUTES_TO.MANAGEMENT_SCHEDULES_MANAGE}/`,
    PERFORMANCE: APP_ROUTES_TO.PERFORMANCE,
    PERFORMANCE_KPIS: APP_ROUTES_TO.PERFORMANCE_KPIS,
    PERFORMANCE_QUALITY_WATCH: APP_ROUTES_TO.PERFORMANCE_QUALITY_WATCH,
    PERFORMANCE_AGENT_QUALITY_MATRIX: `${APP_ROUTES_TO.PERFORMANCE_AGENT_QUALITY_MATRIX}/`,
    PERFORMANCE_CALL_VOLUME: APP_ROUTES_TO.PERFORMANCE_CALL_VOLUME,
    PERFORMANCE_CALENDAR_CAPACITIES: APP_ROUTES_TO.PERFORMANCE_CALENDAR_CAPACITIES,
    PERFORMANCE_APPOINTMENT_ANALYTICS: `${APP_ROUTES_TO.PERFORMANCE_APPOINTMENT_ANALYTICS}/`,
    PERFORMANCE_REACHABILITY_ANALYSIS: `${APP_ROUTES_TO.PERFORMANCE_REACHABILITY_ANALYSIS}/`,
    PERFORMANCE_REPORTS: APP_ROUTES_TO.PERFORMANCE_REPORTS,
    PERFORMANCE_CALL_EXPORTS: `${APP_ROUTES_TO.PERFORMANCE_CALL_EXPORTS}/`,
    PERFORMANCE_SETTING_PRIORITY_REPORT: APP_ROUTES_TO.PERFORMANCE_SETTING_PRIORITY_REPORT,
    PERFORMANCE_SETTING_PRIORITY_LEADS: APP_ROUTES_TO.PERFORMANCE_SETTING_PRIORITY_LEADS,
    PROFILE: `${APP_ROUTES_TO.PROFILE}/`,
    SETTINGS: `${APP_ROUTES_TO.SETTINGS}/`,
    CALENDARS: `${APP_ROUTES_TO.CALENDARS}/`,
    CALENDAR_DETAILS: `${APP_ROUTES_TO.CALENDAR_DETAILS}/`,
    APPOINTMENTS: `${APP_ROUTES_TO.APPOINTMENTS}/`,
    RECORD_DETAILS: APP_ROUTES_TO.RECORD_DETAILS,
    BLOG: APP_ROUTES_TO.BLOG,
    BLOG_DETAIL: APP_ROUTES_TO.BLOG_DETAIL,
    HELP_CENTER: `${APP_ROUTES_TO.HELP_CENTER}/`,
    LISTS: `${APP_ROUTES_TO.LISTS}/`,
    INCIDENTS: `${APP_ROUTES_TO.INCIDENTS}/`,
    CUSTOM_PAGE: APP_ROUTES_TO.CUSTOM_PAGE,
    TESTING: APP_ROUTES_TO.TESTING,
    TESTING_INDEX: "/testing/",
    TESTING_KPIS_REPORT: `${APP_ROUTES_TO.TESTING_KPIS_REPORT}/`,
    TESTING_INCIDENT_ANALYTICS: `${APP_ROUTES_TO.TESTING_INCIDENT_ANALYTICS}/`,
    PRP_SCRIPT: `${APP_ROUTES_TO.PRP_SCRIPT}/`,
    HOTEL_CAPACITY: `${APP_ROUTES_TO.HOTEL_CAPACITY}/`,
} as const satisfies Record<string, FullPath>;
